module.exports = __webpack_public_path__ + "static/employed-a5254b47abc1012a8fc0e501836807a9.png";